import { render, staticRenderFns } from "./PricingItem.vue?vue&type=template&id=42da64a1&scoped=true&"
import script from "./PricingItem.vue?vue&type=script&lang=js&"
export * from "./PricingItem.vue?vue&type=script&lang=js&"
import style0 from "./PricingItem.vue?vue&type=style&index=0&id=42da64a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da64a1",
  null
  
)

export default component.exports